import React, { useRef, useState } from 'react';
import Wrapper from '@components/Wrapper';
import Button from '@components/Button';
import patternLeft from '@patterns/left';
import patternCtaRight from '@patterns/ctaRight';
import patternCtaLeft from '@patterns/ctaLeft';
import patternLeftInverted from '@patterns/leftInverted';
import patternRightInverted from '@patterns/rightInverted';
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './style.module.scss';
import { validateWorkEmail } from '@helpers/validation';
import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next';
import errorIcon from '@icons/errorIcon';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import {signUpUrl} from '@helpers/urls';

const {
  ctaBasic,
  ctaBasic__text,
  ctaBasic__heading,
  ctaBasic__buttons,
  ctaBasic__bgPattern,
  cta,
  cta__block,
  ctaMedium,
  cta__content,
  cta__heading,
  cta__paragraph,
  cta__paragraphSub,
  cta__buttons,
  cta__image,
  cta__imageDesktop,
  cta__imageMobile,
  cta__ticks,
  cta__bgPattern,
  cta__bgPatternRight,
  tick,
  tick__icon,
  tick__text,
  ctaSlim,
  ctaSlim__text,
  ctaSlim__heading,
  ctaSlim__paragraph,
  ctaSlim__buttons,
  cta__form,
  cta__form__input
} = styles;

const Cta = ({
    mode,
    theme="blue",
    classes,
    id,
    content: {
      heading,
      subheading,
      subheadingTrans,
      buttons,
      ticks,
      image,
      windowLocation,
      ctaText,
      ctaLink,
      longText,
      formNameEvent="homepageSignUpForm",
    }
}) => {
  const {t} = useTranslation();
  const {language} = useI18next();

  const buttonRef = useRef();
  const [isDisabled, setDisabled] = useState(false);
  const [btnText, setBtnText] = useState(ctaText);
  const [workEmail, setWorkEmail] = useState('');
  const [workEmailError, setWorkEmailError] = useState(null);

  const unifiedTheme = theme.toLocaleLowerCase();

  const submit = (e) => {
    e.preventDefault();

    const workEmailErrorMessage = validateWorkEmail(workEmail, t);
    setWorkEmailError(workEmailErrorMessage);

    if (!workEmailErrorMessage) {
      setDisabled(true)
      document.cookie = `emailForm=${workEmail};domain=dealfront.com;secure`;
      setTimeout(() => {
        window.location = windowLocation === 'request-demo' ? '/request-demo?ref=dealfront&cta=hero-cta' : signUpUrl(language, { "ref": "dealfront", "cta": "email-capture" });
        setDisabled(false)
      }, 300);
      window.dataLayer.push({
        'event': 'formSubmitted',
        'formName': formNameEvent
      });
    } else {
      var message = 'There are the following errors: ';

      message += `${workEmailErrorMessage}. `;

      window.dataLayer.push({
        'event': 'formError',
        'formName': formNameEvent,
        'formErrors': message
      });
    }
  }

  return (
    <section className={classes} id={id}>
    <Wrapper>
      {mode === 'Basic' && (
        <section className={`${ctaBasic} background--${unifiedTheme}`}>
          <div className={ctaBasic__bgPattern}>
            {patternRightInverted}
            {patternLeftInverted}
          </div>

          { image && image.desktop &&
            <GatsbyImage image={getImage(image.desktop)} alt={image.desktop.description} quality={100} style={{ width: '118px', height: '118px' }}/>
          }

          <div className={ctaBasic__text}>
            <h2 className={ctaBasic__heading}>{heading}</h2>
          </div>
          <div className={ctaBasic__buttons}>
            <Button href={ctaLink} theme='primary' size='large' external={true}>{ctaText}</Button>
          </div>
        </section>
      )}

      {mode === 'Medium' && (
        <section className={`${cta} ${ctaMedium} background--${unifiedTheme}`}>
          <div className={cta__bgPattern}>{ patternLeft }</div>
          <div className={cta__content}>
            <h4 className={cta__heading}>{heading}</h4>
            {subheadingTrans ? 
                <p className={cta__paragraph}>{subheadingTrans}</p>
              :
                <p className={cta__paragraph} dangerouslySetInnerHTML={{__html: subheading}}></p>
            }

            <div className={cta__buttons}>
              {buttons && buttons.map((button, index) => (
                <Button onClick={ () => button.onClick() } theme={button.theme} external={button.external} size={button.size} key={`cta-medium-button-${index}`}>{button.text}</Button>
              ))}
            </div>

            { windowLocation && ctaLink && <form onSubmit={submit} className={`${cta__form} form--secondary`}>
              <div className={cta__form__input}>
                <input
                  className={`form-input${workEmailError ? " error" : ""}`}
                  type="text"
                  name="workemail"
                  aria-label="Work Email"
                  placeholder={t("home_page_heroimage_input_placeholder")}
                  onChange={ e => setWorkEmail(e.target.value) }
                  value={workEmail}
                />
                {
                  workEmailError && <span className="form-error">{errorIcon}{workEmailError}</span>
                }
              </div>

              <button ref={buttonRef} disabled={isDisabled} type='submit' className='button button--primary button--large'>{btnText}</button>
            </form>
          }

          </div>
          <div className={cta__image}>
            <GatsbyImage image={getImage(image?.desktop)} alt="Quote author image" quality={100} />
          </div>
        </section>
      )}
      {mode === 'Normal' && (
        <section className={`${cta} background--${unifiedTheme}`}>
          <div className={cta__bgPattern}>{ patternLeft }</div>
          <div className={cta__content}>
            <h2 className={cta__heading}>{heading}</h2>

            {subheadingTrans ?
                <p className={cta__paragraph}>{subheadingTrans}</p>
              :
                <p className={cta__paragraph} dangerouslySetInnerHTML={{__html: subheading}}></p>
            }

              { <form onSubmit={submit} className={`${cta__form} form--secondary`}>
                <div className={cta__form__input}>
                  <input
                    className={`form-input${workEmailError ? " error" : ""}`}
                    type="text"
                    name="workemail"
                    aria-label="Work Email"
                    placeholder={t("home_page_heroimage_input_placeholder")}
                    onChange={ e => setWorkEmail(e.target.value) }
                    value={workEmail}
                  />
                  {
                    workEmailError && <span className="form-error">{errorIcon}{workEmailError}</span>
                  }
                </div>

                <button ref={buttonRef} disabled={isDisabled} type='submit' className='button button--primary button--large'>{btnText}</button>
              </form>
            }

            {ticks ? (
              <div className={cta__ticks}>
                {ticks.map((tickEl, index) => (
                  <div className={tick} key={`cta-normal-tick-${index}`}>
                    <div className={tick__icon} dangerouslySetInnerHTML={{__html: tickEl.icon.svg.originalContent}}/>
                    <p className={tick__text}>{tickEl.title}</p>
                  </div>
                ))}
              </div>
            ) : <div className={cta__ticks}></div>}

          </div>
          <div className={cta__image}>
            <>
              <GatsbyImage quality={100} className={cta__imageDesktop} image={getImage(image.desktop)} alt="cta image" />
              <GatsbyImage quality={100} className={cta__imageMobile} image={getImage(image.mobile)} alt="cta image" />
            </>
          </div>
        </section>
      )}
      {mode === 'Slim' && (
        <section className={`${ctaSlim} background--${unifiedTheme}`}>
          <div className={ctaSlim__text}>
            <h4 className={ctaSlim__heading} dangerouslySetInnerHTML={{__html: heading}}/>
            <p className={ctaSlim__paragraph} dangerouslySetInnerHTML={{__html: subheading}}/>
          </div>
          <div className={ctaSlim__buttons}>
            <Button href={ctaLink} theme='primary' size='large' external={true}>{ctaText}</Button>
          </div>
        </section>
      )}

      {mode === 'Mid' && (
        <section className={`${cta} background--${unifiedTheme}`}>
          <div className={cta__bgPattern}>{ patternLeft }</div>
          <div className={cta__content}>
            <h2 className={cta__heading}>{heading}</h2>

            {subheadingTrans ?
                <p className={cta__paragraph}>{subheadingTrans}</p>
              :
                <p className={cta__paragraph} dangerouslySetInnerHTML={{__html: subheading}}></p>
            }

              { <form onSubmit={submit} className={`${cta__form} form--secondary`}>
                <div className={cta__form__input}>
                  <input
                    className={`form-input${workEmailError ? " error" : ""}`}
                    type="text"
                    name="workemail"
                    aria-label="Work Email"
                    placeholder={t("home_page_heroimage_input_placeholder")}
                    onChange={ e => setWorkEmail(e.target.value) }
                    value={workEmail}
                  />
                  {
                    workEmailError && <span className="form-error">{errorIcon}{workEmailError}</span>
                  }
                </div>

                <button ref={buttonRef} disabled={isDisabled} type='submit' className='button button--primary button--large'>{btnText}</button>
              </form>
            }
          </div>
          <div className={cta__image}>
            <StaticImage placeholder="none" className={cta__imageDesktop} src='../../../images/cta/cta-inline.png' alt={image.desktop.alt} />
            <StaticImage placeholder="none" className={cta__imageMobile} src='../../../images/cta/cta-inline.png' alt={image.desktop.alt} />
          </div>
        </section>
      )}
      
      {mode === 'Centered' && (
        <section className={`${cta} background--${unifiedTheme} ${cta__block}`}>
          <div className={cta__bgPattern}>{ patternCtaLeft }</div>
          <div className={cta__content}>
            <h2 className={cta__heading}>{heading}</h2>

            {longText ?
                <div className={cta__paragraphSub} dangerouslySetInnerHTML={{__html: longText}}></div>
              :
                <p className={cta__paragraph} dangerouslySetInnerHTML={{__html: subheading}}></p>
            }

              { <form onSubmit={submit} className={`${cta__form} form--secondary`}>
                <div className={cta__form__input}>
                  <input
                    className={`form-input${workEmailError ? " error" : ""}`}
                    type="text"
                    name="workemail"
                    aria-label="Work Email"
                    placeholder={t("home_page_heroimage_input_placeholder")}
                    onChange={ e => setWorkEmail(e.target.value) }
                    value={workEmail}
                  />
                  {
                    workEmailError && <span className="form-error">{errorIcon}{workEmailError}</span>
                  }
                </div>

                <button ref={buttonRef} disabled={isDisabled} type='submit' className='button button--primary button--large'>{btnText}</button>
              </form>
            }

            {ticks ? (
              <div className={cta__ticks}>
                {ticks.map((tickEl, index) => (
                  <div className={tick} key={`cta-normal-tick-${index}`}>
                    <div className={tick__icon} dangerouslySetInnerHTML={{__html: tickEl.icon.svg.originalContent}}/>
                    <p className={tick__text}>{tickEl.title}</p>
                  </div>
                ))}
              </div>
            ) : <div className={cta__ticks}></div>}

          </div>
          <div className={cta__bgPatternRight}>{ patternCtaRight }</div>
        </section>
      )}

      {(mode === 'Centered Rays' || mode === 'Centered Rays - Button Only') && (
        <section className={`${cta} centered-rays background--${unifiedTheme} ${cta__block}`}>
          <div className={cta__content}>
            <h2 className={cta__heading}>{heading}</h2>

            {longText ?
                <div className={cta__paragraphSub} dangerouslySetInnerHTML={{__html: longText}}></div>
              :
                <p className={cta__paragraph} dangerouslySetInnerHTML={{__html: subheading}}></p>
            }

            {mode === 'Centered Rays - Button Only' ? 
              <div className={ctaSlim__buttons}>
                <Button href={ctaLink} theme='primary' size='large' external={true}>{ctaText}</Button>
              </div>
              :
              <form onSubmit={submit} className={`${cta__form} form--secondary`}>
                <div className={cta__form__input}>
                  <input
                    className={`form-input${workEmailError ? " error" : ""}`}
                    type="text"
                    name="workemail"
                    aria-label="Work Email"
                    placeholder={t("home_page_heroimage_input_placeholder")}
                    onChange={ e => setWorkEmail(e.target.value) }
                    value={workEmail}
                  />
                  {
                    workEmailError && <span className="form-error">{errorIcon}{workEmailError}</span>
                  }
                </div>

                <button ref={buttonRef} disabled={isDisabled} type='submit' className='button button--primary button--large'>{btnText}</button>
              </form>
            }

            {ticks ? (
              <div className={cta__ticks}>
                {ticks.map((tickEl, index) => (
                  <div className={tick} key={`cta-normal-tick-${index}`}>
                    <div className={tick__icon} dangerouslySetInnerHTML={{__html: tickEl.icon.svg.originalContent}}/>
                    <p className={tick__text}>{tickEl.title}</p>
                  </div>
                ))}
              </div>
            ) : <div className={cta__ticks}></div>}

          </div>
        </section>
      )}

    </Wrapper>
    </section>
  )
}

export default Cta;
